import { IconArrowDown } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { useScrollToElement } from 'hooks/useScrollToDocument';
import styles from './ScrollToDocumentUploadButton.module.css';

export const ScrollToDocumentUploadButton = () => {
  const { showButton, scrollToElement } = useScrollToElement(
    '#tradingHistory',
    100,
  );

  if (!showButton) {
    return null;
  }

  return (
    <Button onClick={scrollToElement} className={styles.button}>
      Scroll down to proceed
      <IconArrowDown />
    </Button>
  );
};
